/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto } from '../models/Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto';
import type { Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedModulesDto } from '../models/Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedModulesDto';
import type { Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedStatusDto } from '../models/Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserDefinedFieldsSharedService {

    /**
     * @param moduleId
     * @returns Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldsByModuleId(
        moduleId: number,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-defined-fields/user-defined-fields-by-module-id/{ModuleId}',
            path: {
                'ModuleId': moduleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedModulesDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserDefinedFieldsUserDefinedModules(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedModulesDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-defined-fields/user-defined-modules',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserDefinedFieldsUserDefinedStatus(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-defined-fields/user-defined-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
